export default __webpack_public_path__ + "static/media/Hootsuite.6f43348b.png";